// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { IssueDef, IssueRef, IssueUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace IssueActions {
  export class GetAllIssues {
    static readonly type = '[Issue] GetAllIssue';
    readonly type = GetAllIssues.type;
  }

  export class InitIssueCount {
    static readonly type = '[Issue] InitIssuesCount';
    readonly type = InitIssueCount.type;
  }

  export class InitIssue {
    static readonly type = '[Issue] InitIssues';
    readonly type = InitIssue.type;
  }
  export class CountIssues {
    static readonly type = '[Issue] CountIssues';
    readonly type = CountIssues.type;
  }

  export class CloseIssuesConnection {
    static readonly type = '[Issue] CloseIssuesConnection';
    readonly type = CloseIssuesConnection.type;
  }

  export class GetIssueById {
    static readonly type = '[Issue] GetIssueById';
    readonly type = GetIssueById.type;
  }

  export class UpdateIssue {
    static readonly type = '[Issue] UpdateIssue';
    constructor(
      public IissueData: Partial<IssueUpdateData>,
      public ref: IssueRef,
    ) {}
  }

  export class DeleteIssues {
    static readonly type = '[Issue] DeleteIssues';
    constructor(public refs: IssueRef[]) {}
  }

  export class PaginateQueryIssue {
    static readonly type = '[Issue] PaginateQueryIssue';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public issueId?: string,
    ) {}
  }
  export class IssueError {
    static readonly type = '[Issue] IssueError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Issue] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Issue] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public issueId?: string,
    ) {}
  }

  export class UpdateIssueResult {
    static readonly type = '[Issue] UpdateIssueResult';
    constructor(public data: Array<TypesaurusCoreDoc<IssueDef> | null | undefined>) {}
  }
}
